module.exports = __webpack_public_path__ + "img/plus-square-fill.caad2bcd.svg";